var map = {
	"./DisplayPort": [
		8586,
		586
	],
	"./DisplayPort.jsx": [
		8586,
		586
	],
	"./FRC": [
		5019,
		19
	],
	"./FRC.jsx": [
		5019,
		19
	],
	"./FreeSync": [
		669,
		669
	],
	"./FreeSync.jsx": [
		669,
		669
	],
	"./G-SYNC": [
		508,
		508
	],
	"./G-SYNC.jsx": [
		508,
		508
	],
	"./HDCP": [
		9729,
		729
	],
	"./HDCP.jsx": [
		9729,
		729
	],
	"./HDMI": [
		2965,
		965
	],
	"./HDMI.jsx": [
		2965,
		965
	],
	"./HDR": [
		4389,
		389
	],
	"./HDR.jsx": [
		4389,
		389
	],
	"./IPS": [
		3186,
		186
	],
	"./IPS.jsx": [
		3186,
		186
	],
	"./KVM": [
		3497,
		497
	],
	"./KVM.jsx": [
		3497,
		497
	],
	"./OLED": [
		2712,
		712
	],
	"./OLED.jsx": [
		2712,
		712
	],
	"./QLED": [
		628,
		628
	],
	"./QLED.jsx": [
		628,
		628
	],
	"./SPDIF": [
		9278,
		278
	],
	"./SPDIF.jsx": [
		9278,
		278
	],
	"./TN": [
		3931,
		931
	],
	"./TN.jsx": [
		3931,
		931
	],
	"./USB-A": [
		3575,
		575
	],
	"./USB-A.jsx": [
		3575,
		575
	],
	"./USB-B": [
		9801,
		801
	],
	"./USB-B.jsx": [
		9801,
		801
	],
	"./USB-C": [
		8732,
		732
	],
	"./USB-C.jsx": [
		8732,
		732
	],
	"./VA": [
		2757,
		757
	],
	"./VA.jsx": [
		2757,
		757
	],
	"./Vesa-mount": [
		5379,
		379
	],
	"./Vesa-mount.jsx": [
		5379,
		379
	],
	"./audio": [
		1571,
		571
	],
	"./audio.jsx": [
		1571,
		571
	],
	"./mini-DisplayPort": [
		622,
		622
	],
	"./mini-DisplayPort.jsx": [
		622,
		622
	],
	"./picture-by-picture": [
		1982,
		982
	],
	"./picture-by-picture.jsx": [
		1982,
		982
	],
	"./pivot": [
		2199,
		199
	],
	"./pivot.jsx": [
		2199,
		199
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3737;
module.exports = webpackAsyncContext;